/**
 * Keyboard profile configurations
 *
 * @type {Object}
 *
 * @since 7.0.0
 */
export const KeyboardConfiguration = {
    /**
     * Keyboard Profile configuration for an Item List
     *
     * @type {Object}
     *
     * @since 7.0.0
     */
    ITEM_LIST : {
        move_up : {
            delay     : 220,
            shortcuts : [
                {k: 'ArrowUp', m: []},
            ]
        },

        move_down : {
            delay     : 220,
            shortcuts : [
                {k: 'ArrowDown', m: []},
            ]
        },

        select_up : {
            shortcuts : [
                {k: 'ArrowUp', m: ['ctrlKey']},
                {k: 'ArrowUp', m: ['shiftKey']},
                {k: 'ArrowUp', m: ['ctrlKey', 'shiftKey']},
            ]
        },

        select_down : {
            shortcuts : [
                {k: 'ArrowDown', m: ['ctrlKey']},
                {k: 'ArrowDown', m: ['shiftKey']},
                {k: 'ArrowDown', m: ['ctrlKey', 'shiftKey']},
            ]
        },

        open : {
            shortcuts : [
                {k: 'Enter', m: []},
            ]
        },

        delete : {
            shortcuts : [
                {k: 'Delete', m: []},
            ]
        }
    },

    /**
     * Keyboard Profile configuration for an Open Item
     *
     * @type {Object}
     *
     * @since 7.0.0
     */
    ITEM_OPEN : {
        close : {
            shortcuts : [
                {k: 'Escape', m: []},
            ]
        },
        delete : {
            shortcuts : [
                {k: 'Delete', m: []}
            ]
        }
    },

    /**
     * Keyboard Profile configuration for simple overlays, like modal windows
     *
     * @type {Object}
     *
     * @since 7.0.0
     */
    SIMPLE_OVERLAY : {
        close : {
            shortcuts : [
                {k: 'Escape', m: []},
            ]
        }
    }
}

/**
 * A list of all declared keyboard profiles used in the application
 *
 * This list is used to declare all available profiles in the application
 * so it's easier to manage and maintain the profiles
 *
 * @type {Object} KeyboardProfile
 *
 * @since 7.0.0
 */
export const KeyboardProfile = {
    MESSAGES_ITEM_LIST : {
        name   : 'MESSAGES_ITEM_LIST',
        config : KeyboardConfiguration.ITEM_LIST,
    },

    MESSAGE_ITEM_OPEN : {
        name   : 'MESSAGE_ITEM_OPEN',
        config : KeyboardConfiguration.ITEM_OPEN,
    },

    ATTACHMENTS_GALLERY : {
        name   : 'ATTACHMENTS_GALLERY',
        config : KeyboardConfiguration.SIMPLE_OVERLAY,
    },

    SIMPLE_MODAL : {
        name   : 'SIMPLE_MODAL',
        config : KeyboardConfiguration.SIMPLE_OVERLAY,
    }
}
